export const FAQ_CONTENT = {
  eyebrow: 'GOT QUESTIONS?',
  title: 'Frequently Asked',
  highlight: 'Questions',
  description:
    'Everything you need to know before starting your Quran learning journey with us.',
}

export const FAQ_ITEMS = [
  {
    question: 'How do the free trial classes work?',
    answer:
      'Every new student receives two completely free trial classes with a teacher matched to their level and goals. These sessions are full-length, with no obligation to continue. They allow you to evaluate the teaching style, platform, and fit — before making any commitment.',
  },
  {
    question: 'Are the teachers certified?',
    answer:
      'Yes. All our teachers hold a verified Ijazah — a chain of authentic Islamic transmission connecting their recitation back to the Prophet Muhammad ﷺ. We also verify their teaching qualifications, background, and conduct regular performance reviews.',
  },
  {
    question: 'Can my child learn online if they are very young?',
    answer:
      'Absolutely. We have specialized teachers trained in child-friendly, playful methods for students as young as 4 years old. Sessions are structured shorter for younger students to match their attention spans while keeping them engaged.',
  },
  {
    question: 'What if I need to reschedule a class?',
    answer:
      'Life happens — we get it. You can reschedule any class up to 2 hours before it starts with no penalty. Our support team is available around the clock to help with scheduling changes or any other needs.',
  },
  {
    question: 'Do you offer classes for sisters and female students?',
    answer:
      'Yes. We have a dedicated pool of qualified female teachers available for sisters and children who prefer a female instructor. Many families specifically choose us for this reason, and we take great care in matching students appropriately.',
  },
  {
    question: 'What courses do you offer?',
    answer:
      'We offer Quran Recitation, Tajweed Mastery, Hifz (Memorization), Noorani Qaida for beginners, Ijazah Certification programs, Arabic Language, and comprehensive Islamic Studies covering Aqeedah, Fiqh, and Seerah.',
  },
  {
    question: 'How long does it take to complete the Quran memorization?',
    answer:
      'This varies by student, but on average students who attend 5 sessions per week complete full Hifz within 2 to 4 years. We provide structured milestones and regular revision sessions to ensure strong long-term retention.',
  },
  {
    question: 'What technology do I need for classes?',
    answer:
      'Just a device with a working camera and microphone — a smartphone, tablet, or computer works great. Classes run on a simple, secure video platform. We will walk you through setup before your first session.',
  },
]
